import MiResizeObserver from './MiResizeObserver.vue'

export default MiResizeObserver
